import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, FacebookAuthProvider, TwitterAuthProvider } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDKWYYXiPgEA8mtCRNf3-m4rGuKIu6qH0o",
  authDomain: "lazerzone-aaed3.firebaseapp.com",
  projectId: "lazerzone-aaed3",
  storageBucket: "lazerzone-aaed3.firebasestorage.app",
  messagingSenderId: "1049601699542",
  appId: "1:1049601699542:web:bc41bc9b486e9368082377",
  measurementId: "G-C97N3JK946"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const analytics = getAnalytics(app);

// Proveedores de autenticación
const googleProvider = new GoogleAuthProvider();
const facebookProvider = new FacebookAuthProvider();
const twitterProvider = new TwitterAuthProvider();

export { auth, googleProvider, facebookProvider, twitterProvider };
